import React from 'react';
import {Link} from 'react-router-dom';

import './slider.css';

import Reader from '../reader/reader';
import PropTypes from 'prop-types';
import VideoPlayer from '../video-player/video-player';

const data = require('../../data.json');
const slidesTotal = data.length;

class Slider extends React.Component {
  constructor(props) {
    super(props);
    this.slideHandler = this.slideHandler.bind(this);
    this.handlePopup = this.handlePopup.bind(this);
    this.handleReader = this.handleReader.bind(this);
    this.playVideo = this.playVideo.bind(this);
    this.play = this.play.bind(this);
  }

  state = {
    currentSlide: 0,
    prevSlide: 0,
    nextSlide: 0,
    prevText: false,
    nextText: false,
    popup: false,
    reader: false,
    play: false,
    video: false
  };

  play() {
    const audio = document.querySelector('.slider__audio');
    if (audio.paused) {
      audio.play();
      this.setState({play: true});
    } else {
      audio.pause();
      this.setState({play: false});
    }
  }

  playVideo() {
    this.setState((previousState) => ({
      video: !previousState.video
    }));
  }

  handleReader() {
    // Const reader = this.state.reader;
    this.setState((previousState) => ({
      reader: !previousState.reader
    }));
  }

  handlePopup() {
    // Const popup = this.state.popup;
    this.setState((previousState) => ({
      popup: !previousState.popup
    }));
  }

  componentDidMount() {
    this.setState({
      currentSlide: this.props.currentPage,
      prevSlide:
        this.props.currentPage === 0
          ? slidesTotal - 1
          : this.props.currentPage - 1,
      nextSlide:
        this.props.currentPage === slidesTotal - 1
          ? 0
          : this.props.currentPage + 1
    });
  }

  slideHandler(event) {
    const direction = event.currentTarget.dataset.direction;
    // this.setState({play: false});
    this.setState((previousState) => {
      let newIndex = previousState.currentSlide;
      let leftIndex = previousState.prevSlide;
      let rightIndex = previousState.nextSlide;
      if (direction === 'next') {
        newIndex += 1;
        leftIndex += 1;
        rightIndex += 1;
      } else {
        newIndex -= 1;
        leftIndex -= 1;
        rightIndex -= 1;
      }

      if (newIndex < 0) {
        newIndex = slidesTotal - 1;
      } else if (newIndex === slidesTotal) {
        newIndex = 0;
      }

      if (leftIndex < 0) {
        leftIndex = slidesTotal - 1;
      } else if (leftIndex === slidesTotal) {
        leftIndex = 0;
      }

      if (rightIndex < 0) {
        rightIndex = slidesTotal - 1;
      } else if (rightIndex === slidesTotal) {
        rightIndex = 0;
      }

      return {
        currentSlide: newIndex,
        prevSlide: leftIndex,
        nextSlide: rightIndex
      };
    });
  }

  render() {
    // Const index = this.props.currentPage;
    return (
      <div
        className="slider"
        style={{backgroundColor: data[this.state.currentSlide].background}}
      >
        <VideoPlayer
          playVideo={this.playVideo}
          video={data[this.state.currentSlide].video}
        />
        {this.state.reader ? (
          <Reader
            hideReader={this.handleReader}
            readerName={data[this.state.currentSlide].painterFullName}
            readerText={data[this.state.currentSlide].text}
          />
        ) : null}
        <div
          className="slider__popup"
          style={{display: this.state.popup ? 'block' : null}}
        >
          <div className="slider__popup-button" onClick={this.handlePopup}>
            <img
              alt="Закрыть меню"
              className="slider__close"
              src="./images/close.png"
            />
          </div>
          <div className="slider__popup-list">
            <Link
              className="link slider__popup-list-item"
              to="/main"
            >
              На главную
            </Link>
            {/* <a
              className="link slider__popup-list-item"
              href="https://ok.ru/visitfinland/app/512000898984"
              rel="noopener noreferrer"
              target="_blank"
            >
              Пройти тест
            </a> */}
          </div>
        </div>
        <div
          className="slider__menu-button"
          onClick={this.handlePopup}
          style={{visibility: this.state.popup ? 'hidden' : null}}
        >
          <div className="slider__menu-button-line" />
          <div className="slider__menu-button-line" />
          <div className="slider__menu-button-line" />
        </div>
        <div className="slider__header-container">
          <div className="slider__header">
            {data[this.state.currentSlide].painterFullName}
          </div>
        </div>
        <div className="slider__images" style={{opacity: 0}}>
          <div
            className="slider__image-left"
            style={{
              backgroundImage: `url(./images/painters/PAINTINGS_FULL/${
                data[this.state.prevSlide].paintingBig
              })`
            }}
          />
          <div
            className="slider__image"
            style={{
              backgroundImage: `url(./images/painters/PAINTINGS_FULL/${
                data[this.state.currentSlide].paintingBig
              })`
            }}
          />
          <div
            className="slider__image-right"
            style={{
              backgroundImage: `url(./images/painters/PAINTINGS_FULL/${
                data[this.state.nextSlide].paintingBig
              })`
            }}
          />
        </div>
        <div className="slider__buttons">
          <div
            className="slider__button"
            data-direction="prev"
            onClick={this.slideHandler}
          >
            <div
              className="slider__button-text"
            >
              Предыдущая картина
            </div>
            <div
              className="slider__button-button"
              style={{backgroundImage: `url(./images/prev.png)`}}
            />
          </div>
          {/* <div
            className="slider__button-main"
            onClick={
              data[this.state.currentSlide].video
                ? () => this.playVideo()
                : this.play
            }
            style={{
              backgroundImage: this.state.play
                ? `url(./images/pause.png)`
                : `url(./images/play.png)`
            }}
          /> */}
          <div
            className="slider__reader-window"
            style={{
              backgroundImage: `url(./images/readers/${
                data[this.state.currentSlide].reader
              })`
            }}
          />
          <div
            className="slider__button"
            data-direction="next"
            onClick={this.slideHandler}
          >
            <div
              className="slider__button-button"
              style={{backgroundImage: `url(./images/next.png)`}}
            />
            <div
              className="slider__button-text"
            >
              Следующая картина
            </div>
          </div>
        </div>
        <div className="slider__reader-name">
          При участии: {
            data[this.state.currentSlide].readerFullNameExtra ? 
            <span dangerouslySetInnerHTML={{__html: data[this.state.currentSlide].readerFullNameExtra}} />
            : <a href={data[this.state.currentSlide].readerLink} className="slider__link" rel="noreferrer noopener" target="_blank">{data[this.state.currentSlide].readerFullName}</a>
          }
        </div>
      </div>
    );
  }
}

Slider.propTypes = {
  currentPage: PropTypes.number,
  data: PropTypes.array,
  handleIndex: PropTypes.func
};

export default Slider;
